import { ComponentProps, ReactNode, useCallback, useMemo } from 'react';
import { Controller } from 'react-hook-form';

import { ActiveDot, Box, Switch } from '@sbv-clients/ui-shared';

type FormToggleWithLabelsProps = ComponentProps<typeof Switch> & {
  name: string;
  active?: boolean;
};

type RenderType = ComponentProps<typeof Controller>['render'];
export const FormToggleField = ({
  name,
  leftLabel,
  rightLabel,
  disabled,
  variant,
  onChange,
  active,
  ...rest
}: FormToggleWithLabelsProps) => {
  const resolvedRightLabel: ReactNode = useMemo(() => {
    return active && rightLabel ? (
      <Box display="flex" alignItems="center" gap={1}>
        {rightLabel}
        <ActiveDot />
      </Box>
    ) : (
      rightLabel
    );
  }, [active, rightLabel]);

  const render: RenderType = useCallback(
    ({ field }) => (
      <Switch
        variant={variant}
        checked={field.value}
        leftLabel={leftLabel}
        rightLabel={resolvedRightLabel}
        disabled={disabled}
        onChange={(event, checked) => {
          field.onChange(event, checked);
          onChange?.(event, checked);
        }}
        {...rest}
      />
    ),
    [variant, leftLabel, resolvedRightLabel, disabled, rest, onChange]
  );

  return <Controller name={name} render={render} />;
};
